const uploadCarValidation = (formData) => {
  let errors = {};
  const minPrice = Number(formData.carDetails.minPrice);
  const buyNowPrice = Number(formData.carDetails.buyNowPrice);
  

  // Add validations for carDetails
  if (!formData.carDetails.vin) {
    errors.vin = "VIN is required";
  }

  if (!formData.carDetails.year) {
    errors.year = "Year is required";
  } else if (!Number.isInteger(Number(formData.carDetails.year))) {
    errors.year = "Year must be an integer";
  } else if (Number(formData.carDetails.year) > new Date().getFullYear()) {
    errors.year = "Year cannot be in the future";
  }

  if(formData.carDetails.zip && !/^[A-Za-z0-9\s-]+$/.test(formData.carDetails.zip)) {
    errors.zip = "Zip code can only include letters, numbers, spaces, and hyphens.";
  }


  if (!formData.carDetails.make) errors.make = "Make is required";
  if (!formData.carDetails.model) errors.model = "Model is required";
  if (!formData.carDetails.transmission)
    errors.transmission = "Transmission is required";
  if (!formData.carDetails.mileage) {
    errors.mileage = "Mileage is required";
  }

  // if (!formData.carDetails.description)
  //   errors.description = "Description is required";
  if (!formData.carDetails.carLocation)
    errors.carLocation = "Car location is required";
  if (!formData.carDetails.carTitledAt)
    errors.carTitledAt = "Car titled at is required";
  if (!formData.carDetails.titlesStatus)
    errors.titlesStatus = "Drivability status is required";
    if (!formData.carDetails.titlesStatus)
    errors.titlesStatus = "Drivability status is required";
  if (!formData.carDetails.referral) errors.referral = "Referral is required";

  if (
    !formData.carDetails.transmission ||
    formData.carDetails.transmission === "Select transmission type"
  ) {
    errors.transmission = "Transmission is required";
  }

  // Require island only when car is located in Bahamas
  if (
    formData.carDetails.carLocation === "Bahamas" &&
    !formData.carDetails.carState
  )
    errors.carState = "Island is required";
  if (
    formData.carDetails.carTitledAt === "Bahamas" &&
    !formData.carDetails.bahamasState
  ) {
    errors.bahamasState = "Island is required";
  }

  if (!formData.carImages || formData.carImages.length === 0) {
    errors.carImages = "Car images are required";
  }

  if (!formData.carDocuments || formData.carDocuments.length === 0) {
    errors.carDocuments = "Car documents are required";
  }

  if (
    formData.carDetails.minPrice &&
    formData.carDetails.buyNowPrice &&
    buyNowPrice <= minPrice
  ) {
    errors.buyNowPrice =
      "Buy Now Price must be greater than the Reserve Price.";
  }

  return errors;
};

export default uploadCarValidation;
